import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

/** True when the required env vars are present and non-empty. */
export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

if (!isSupabaseConfigured) {
  console.warn(
    '[Ridgen] Supabase env vars missing (VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY). ' +
      'Auth and cloud sync will not function. Set them in .env.local or Vercel project settings.',
  );
}

// Always export a client so imports never fail, but when unconfigured the client
// will return errors from every API call rather than crashing on construction.
// `||` (not `??`) is intentional: matches the empty-string handling in `isSupabaseConfigured` above so empty env vars fall through to placeholders.
export const supabase = createClient(supabaseUrl || 'https://placeholder.supabase.co', supabaseAnonKey || 'placeholder', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'ridgen-auth',
  },
});
